<template>
  <div>
    <div id="head">邀请</div>
    <div id="heading">
      <div>
        <img id="img"
             :src="dataMap.face"
             alt="头像">
      </div>
      <div id="title">
        {{ dataMap.title }}
      </div>
    </div>
    <div id="plate">{{ dataMap.plate }}</div>
    <div id="time">{{ dataMap.time }}</div>
    <el-input v-model="input" class="inputEl" placeholder="请输入你的手机号"></el-input>
    <el-button id="butt-size" class="ToolBar" @click="menuOpen(2)">确认</el-button>
  </div>
</template>

<script>
import {h5, invite} from '../api/api';

export default {
  name: "invite",
  data() {
    return {
      input: '',
      id: 0,
      // dataMap: {
      //   plate: '赣B 1556V',
      //   title: '"皮皮"邀请您关注车辆',
      //   face: 'https://thirdwx.qlogo.cn/mmopen/vi_32/ndPuFlMmQ4GCvxibC5LWhg7xzXqjEEsN85GtNhSs57MmhSIbD6niaoWibP3EfeQFUtLeax4qfEXcbnjGEuhJibus8Q/132',
      //   time: '2021-08-02 12:52',
      //   phone: '',
      //   type: 0
      // }
      dataMap: {
        plate: '',
        title: '',
        face: '',
        time: '',
        phone: '',
        type: 0
      }
    };
  },
  components: {},
  mounted: function () {
    this.getData();
  },
  methods: {
    //获取页面数据
    getData() {
      let path = this.$router.currentRoute.path;
      let id = path.replace("/invite/", "")
      this.id = id;
      //先判断手机号码是否一致
      let data = {id: id};
      invite(data).then(res => {
        let {code, msg, data} = res;
        if (code === 0) {
          this.dataMap = data;
        } else {
          this.$message.error(msg);
          this.$router.push({path: '/app'});
        }
      })
    },
    //同意
    menuOpen(s) {
      //先判断手机号码是否一致
      if (this.input.trim() === "") {
        this.$message.error("手机号码能为空");
      } else if (this.input.trim() !== this.dataMap.phone.trim()) {
        this.$message.error("手机号错误，请重新输入");
      } else {
        let data = {remark: this.input, isLook: s, id: this.id};
        h5(data).then(res => {
          let {code, msg, data} = res;
          if (code === 101) {
            this.$message.success(msg);
            this.$router.push({path: '/app'});
          } else if (code === 102) {
            this.$message.success(msg);
            this.$router.push({path: '/app'});
          } else {
            this.$message.error(msg);
            this.$router.push({path: '/app'});
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.inputEl {
  position: absolute;
  width: 250px !important;
  height: 47px;
  top: 252px;
  left: 50%;
  margin-left: -125px;
}

#time {
  position: absolute;
  width: 112px;
  height: 19px;
  font-size: 13px;
  font-family: PingFang SC, sans-serif;
  font-weight: 500;
  line-height: 27px;
  color: #969696;
  opacity: 1;
  top: 182px;
  left: 50%;
  margin-left: -56px;
}

#plate {
  position: absolute;
  width: 208px;
  height: 48px;
  border: 1px solid #C9CACA;
  border-radius: 7px;
  left: 50%;
  top: 125px;
  margin-left: -104px;
  text-align: center;
  font-size: 27px;
  font-family: PingFang SC, sans-serif;
  font-weight: 500;
  line-height: 48px;
  color: #000000;
  opacity: 1;
}

#title {
  width: 200px;
  height: 24px;
  line-height: 23px;
  font-size: 17px;
  font-family: PingFang SC, sans-serif;
  font-weight: 500;
  color: #000000;
  opacity: 1;
  position: absolute;
  left: 36px;
  top: 6px;
}

#img {
  position: absolute;
  height: 36px;
  width: 36px;
  left: 0;
}

#heading {
  position: relative;
  height: 36px;
  width: 240px;
  text-align: center;
  top: 70px;
  left: 50%;
  margin-left: -120px;
}

#head {
  position: absolute;
  top: 0;
  text-align: center;
  z-index: 2;
  font-weight: bolder;
  vertical-align: middle;
  width: 100%;
  height: 50px;
  font-size: 18px;
  line-height: 60px;
  color: #000000;
  opacity: 1;
  border-bottom: 2px solid #D0D0D0;
  background: #FFFFFF;
}

.ToolBar {
  position: absolute;
  bottom: 200px;
  text-align: center;
  z-index: 2;
  overflow: hidden;
  width: 110px !important;
  height: 47px;
}

#butt-size {
  position: absolute;
  right: 50%;
  margin-right: -55px;
  background-color: #000000;
  color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/components/invite.vue